import { parsePluginVersion } from '@/lib/host-bridge/plugin-version';

const DEFAULT_RECOMMENDED_RHINO_PLUGIN_VERSION = '2.0.0';

export function getRecommendedRhinoPluginVersion(): string {
  const configured =
    process.env.NEXT_PUBLIC_RHINO_PLUGIN_RECOMMENDED_VERSION?.trim();
  if (configured && parsePluginVersion(configured)) {
    return configured;
  }

  return DEFAULT_RECOMMENDED_RHINO_PLUGIN_VERSION;
}

export const RECOMMENDED_RHINO_PLUGIN_VERSION =
  getRecommendedRhinoPluginVersion();
